import SchoolIcon from '@mui/icons-material/School';
import { useTranslation } from 'react-i18next';

import HomeBarButton from '@core/dashboard/components/HomeBarButton';

import { useTutorial } from '../TutorialProvider';

/**
 * Manual QA control, shown in the home bottom bar, that force-opens the
 * guided-tutorial prompt modal on demand, bypassing the one-time localStorage
 * gate and the "landed in the experience" screen check. Hidden while a
 * tutorial is already running.
 */
const TutorialTestButton = () => {
  const { t: translate } = useTranslation();
  const { isTutorialRunning, openTutorialPrompt } = useTutorial();

  if (isTutorialRunning) {
    return null;
  }

  return (
    <HomeBarButton
      icon={<SchoolIcon />}
      handleClick={openTutorialPrompt}
      label={translate('guidedTutorial.testOpenPrompt')}
      dataTestId="tutorial-test-open-btn"
    />
  );
};

export default TutorialTestButton;
